import { render, staticRenderFns } from "./MemberWindow.vue?vue&type=template&id=4b570369"
import script from "./MemberWindow.vue?vue&type=script&lang=js"
export * from "./MemberWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports